// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  relId: __t.u64().primaryKey().name("rel_id"),
  versonaId: __t.u64().name("versona_id"),
  identity: __t.identity(),
  worldId: __t.u64().name("world_id"),
  seenCount: __t.u32().name("seen_count"),
  lastSeenAt: __t.timestamp().name("last_seen_at"),
  lastTalkDay: __t.u32().name("last_talk_day"),
  talkStreak: __t.u32().name("talk_streak"),
  lastGiftDay: __t.u32().name("last_gift_day"),
  lastGiftKey: __t.string().name("last_gift_key"),
  nemesis: __t.bool(),
  rival: __t.bool(),
  updatedAt: __t.timestamp().name("updated_at"),
});
